import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import DeletedNotes from "./components/DeletedNotes";
import ArchivedNotes from "./components/ArchivedNotes";
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/deleted-notes",
    element: <DeletedNotes />,
  },
  {
    path: "/archived",
    element: <ArchivedNotes />,
  },
]);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
